import { render, staticRenderFns } from "./cPeopleFilter.vue?vue&type=template&id=716a089d&scoped=true"
import script from "./cPeopleFilter.vue?vue&type=script&lang=js"
export * from "./cPeopleFilter.vue?vue&type=script&lang=js"
import style0 from "./cPeopleFilter.vue?vue&type=style&index=0&id=716a089d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716a089d",
  null
  
)

export default component.exports